import React from 'react';
import { TimelineEvent } from './Timeline';

interface TimelineEventMarkerProps {
  event: TimelineEvent;
  position: number;
  isActive: boolean;
  index: number;
}

export const TimelineEventMarker: React.FC<TimelineEventMarkerProps> = ({
  event,
  position,
  isActive,
  index
}) => {
  return (
    <div
      key={event.year + index + event.title}
      className={`eventMarker ${isActive ? 'active' : ''}`}
      style={{ left: `${position}%` }}
    >
      <div className="year">{event.year}</div>
      <div className="title">{event.title}</div>
      <div className="year-line"></div>
    </div>
  );
}; 